import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Input class={{concat \"input \" this._isInvalid \" \" this.inputClassNames}} placeholder={{this.placeholder}} disabled={{this.disabled}} />", {
  moduleName: "@dashboard/shared-ui/components/sq-input-money.hbs"
});